import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  backgroundColor,
  datasetXY,
  datasetPivot,
  initPivot,
  label,
  pivotAdapter,
  pivotColumnDimensions,
  pivotGridStyle,
  pivotIndicators,
  pivotIndicatorsAsCol,
  pivotRowDimensions,
  tooltip,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
  initFunnel,
  discreteLegend,
  color,
  funnelStyle,
  linearColor,
  colorAdapter,
  colorLegend,
  colorFunnelStyleFill,
  pivotDiscreteLegend,
  pivotColorLegend,
  pivotHideIndicatorName,
  funnelTransformStyle,
  pivotTitle,
  addRegionPadding,
  fontFamilyTheme,
} from '../pipes'

const funnel: VChartSpecPipeline = [
  fontFamilyTheme,
  initFunnel,
  backgroundColor,
  datasetXY,
  colorAdapter(color, linearColor),
  label,
  colorAdapter(discreteLegend, colorLegend),
  colorFunnelStyleFill(funnelStyle),
  funnelTransformStyle,
  tooltip({ titleEncoding: 'color' }),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
]

const pivotFunnel: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsCol,
  pivotHideIndicatorName,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initFunnel,
    addRegionPadding,
    backgroundColor,
    datasetXY,
    colorAdapter(color, linearColor),
    label,
    tooltip({ titleEncoding: 'color' }),
    colorFunnelStyleFill(funnelStyle),
    funnelTransformStyle,
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationArea,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
]

export const funnelSpecPipeline = [pivotAdapter(funnel, pivotFunnel)]
